<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Daily Job Plans'
                    : 'Deleted DailyJobPlans'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 380px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="380"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: 130px">
                        Walker Assigned
                      </th>
                      <th class="text-left" style="min-width: 95px">Pet</th>
                      <th class="text-left" style="min-width: 115px">Pet 2</th>
                      <th class="text-left" style="min-width: none">Date</th>
                      <th class="text-left" style="min-width: 790px">Walks</th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="daily_job_plans.length != 0">
                    <tr
                      v-for="(daily_job_plan, i) in daily_job_plans"
                      :key="`daily_job_plan_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': daily_job_plans.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="planStatus(daily_job_plan)"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              :color="planStatus(daily_job_plan).color"
                              :text-color="planStatus(daily_job_plan).textColor"
                            >
                              <v-avatar left>
                                <v-icon size="15">{{
                                  planStatus(daily_job_plan).icon
                                }}</v-icon>
                              </v-avatar>
                              {{ planStatus(daily_job_plan).text }}
                            </v-chip>
                          </template>
                          <span>{{ planStatus(daily_job_plan).tooltip }}</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ daily_job_plan.walker?.user_name || "Not Assigned" }}
                      </td>
                      <td>{{ daily_job_plan.user_pet?.name || "-" }}</td>
                      <td>
                        {{
                          daily_job_plan.user_pet_2
                            ? daily_job_plan.user_pet_2.name
                            : ""
                        }}
                      </td>
                      <td style="min-width: 115px">
                        {{ daily_job_plan.date || "" }}
                      </td>
                      <td style="min-width: 380px">
                        <template
                          v-if="daily_job_plan.daily_job_plan_walks.length"
                        >
                          <v-expansion-panels class="my-2">
                            <v-expansion-panel>
                              <v-expansion-panel-header
                                color="primary"
                                class="white--text"
                              >
                                List of Walks
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-simple-table
                                  fixed-header
                                  class="striped-table"
                                >
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th style="width: 85">Status</th>
                                        <th style="width: 95">Walker</th>
                                        <th style="width: 95">
                                          Starting Selfie
                                        </th>
                                        <th style="width: 95">Ending Selfie</th>
                                        <th style="width: 95">Timeslot</th>
                                        <th style="width: 95">
                                          Distance Covered
                                        </th>
                                        <th style="width: 95">
                                          Calories Burnt
                                        </th>
                                        <th style="width: 95">Rating</th>
                                        <th style="width: 95">Feedback</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(
                                          walk, dJPW
                                        ) in daily_job_plan.daily_job_plan_walks"
                                        :key="`detail_${dJPW}`"
                                        :class="{
                                          'table-row-even': i % 2 === 0,
                                          'table-row-odd': i % 2 !== 0,
                                          'table-row-last':
                                            daily_job_plan.daily_job_plan_walks
                                              .length -
                                              1 ==
                                            i,
                                        }"
                                      >
                                        <td>
                                          <v-tooltip
                                            bottom
                                            v-if="walkStatuses[walk.status]"
                                          >
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <v-chip
                                                v-bind="attrs"
                                                v-on="on"
                                                small
                                                :color="
                                                  walkStatuses[walk.status].color
                                                "
                                                :text-color="
                                                  walkStatuses[walk.status]
                                                    .textColor
                                                "
                                              >
                                                <v-avatar left>
                                                  <v-icon size="15">{{
                                                    walkStatuses[walk.status]
                                                      .icon
                                                  }}</v-icon>
                                                </v-avatar>
                                                {{
                                                  walkStatuses[walk.status].text
                                                }}
                                              </v-chip>
                                            </template>
                                            <span>{{
                                              walkStatuses[walk.status].tooltip
                                            }}</span>
                                          </v-tooltip>
                                        </td>
                                        <td>{{ walk.walker?.user_name || "Not Assigned" }}</td>
                                        <td></td>
                                        <td></td>
                                        <td>{{ walk.timeslot }}</td>
                                        <td>{{ walk.distance_covered }}</td>
                                        <td>{{ walk.calories_burnt }}</td>
                                        <td>{{ walk.rating }}</td>
                                        <td>{{ walk.feedback }}</td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </template>
                        <template v-else> </template>
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(daily_job_plan.created_at) }}
                      </td>
                      <td class="text-right" style="min-width: 155px">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'monthly_bookings'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="error"
                                @click="OpenWarning(daily_job_plan.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Request</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'monthly_bookings'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(daily_job_plan.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this daily_job_plan</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Status Change Warning Dialog Box -->
      <v-dialog v-model="show_Warning_popUp" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>
                        Are you sure to
                        {{
                          selected_requested.status == "1"
                            ? "Approve"
                            : "Reject"
                        }}?.
                      </h3>
                      <br />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-can:edit="'monthly_bookings'"
                        color="success"
                        @click="
                          (show_Warning_popUp = false),
                            confirmUpdate(selected_requested)
                        "
                      >
                        Confirm
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="red"
                        dark
                        @click="
                          (show_Warning_popUp = false),
                            (selected_requested = {})
                        "
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_daily_job_plan" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Request deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_daily_job_plan = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_daily_job_plan" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>DailyJobRequest restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_daily_job_plan = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "DailyJobPlansPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      daily_job_plans: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      walkStatuses: {
        0: {
          text: "PENDING",
          color: "yellow",
          textColor: "black",
          icon: "mdi-clock-outline",
          tooltip: "Walk is pending",
        },
        1: {
          text: "STARTED",
          color: "blue",
          textColor: "white",
          icon: "mdi-play-circle",
          tooltip: "Walk is started",
        },
        2: {
          text: "COMPLETED",
          color: "green",
          textColor: "white",
          icon: "mdi-checkbox-marked-circle",
          tooltip: "Walk is completed",
        },
        3: {
          text: "RESCHEDULED",
          color: "orange",
          textColor: "white",
          icon: "mdi-calendar-refresh",
          tooltip: "Walker on leave, walk is being reassigned",
        },
        4: {
          text: "MOVED",
          color: "orange",
          textColor: "white",
          icon: "mdi-calendar-arrow-right",
          tooltip: "Customer moved this walk to another date",
        },
        7: {
          text: "CANCELLED",
          color: "grey",
          textColor: "white",
          icon: "mdi-cancel",
          tooltip: "Walk cancelled by customer",
        },
      },
      ExportDailyJobRequestTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_daily_job_plan: false,
      is_deleted_daily_job_plan: false,
      restore_daily_job_plan: false,
      is_restored_daily_job_plan: false,
      show_Warning_popUp: false,
      pendingRequestId: "",
      is_confirmed_delete: "",
      to_be_deleted_id: "",
      deleteDialog: "",
      selected_requested: {},
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.filter.user_monthly_job_request_id = this.$route.query
      .user_monthly_job_request_id
      ? this.decryptIt(this.$route.query.user_monthly_job_request_id)
      : "";
    this.getData();
  },
  methods: {
    // Day status is derived from its walks; daily_job_plans.status is never maintained.
    planStatus(daily_job_plan) {
      const allWalks = daily_job_plan.daily_job_plan_walks || [];
      if (!allWalks.length) return null;

      // Walks moved to another date (4) or cancelled (7) no longer belong to this day
      const walks = allWalks.filter((w) => ![4, 7].includes(Number(w.status)));
      if (!walks.length) {
        const cancelled = allWalks.some((w) => w.status == 7);
        return cancelled
          ? {
              text: "Cancelled",
              color: "grey",
              textColor: "white",
              icon: "mdi-cancel",
              tooltip: "Walk cancelled by customer",
            }
          : {
              text: "Moved",
              color: "orange",
              textColor: "white",
              icon: "mdi-calendar-arrow-right",
              tooltip: "Customer moved this walk to another date",
            };
      }

      const total = walks.length;
      const count = (status) => walks.filter((w) => w.status == status).length;
      const started = count(1);
      const completed = count(2);
      const rescheduled = count(3);
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
        now.getDate()
      )}`;

      if (completed == total)
        return {
          text: "Completed",
          color: "green",
          textColor: "white",
          icon: "mdi-checkbox-marked-circle",
          tooltip: "All walks of the day are completed",
        };
      if (started)
        return {
          text: "In Progress",
          color: "blue",
          textColor: "white",
          icon: "mdi-play-circle",
          tooltip: "A walk is currently in progress",
        };
      if (completed)
        return {
          text: `Partial (${completed}/${total})`,
          color: "teal",
          textColor: "white",
          icon: "mdi-progress-check",
          tooltip: `${completed} of ${total} walks completed`,
        };
      if (rescheduled)
        return {
          text: "Rescheduled",
          color: "orange",
          textColor: "white",
          icon: "mdi-calendar-refresh",
          tooltip: "Walker on leave, walk is being reassigned",
        };
      if (daily_job_plan.date && daily_job_plan.date < today)
        return {
          text: "Missed",
          color: "red",
          textColor: "white",
          icon: "mdi-close-circle",
          tooltip: "Date has passed and no walk was completed",
        };
      return {
        text: "Scheduled",
        color: "yellow",
        textColor: "black",
        icon: "mdi-clock-outline",
        tooltip: "Walk is scheduled",
      };
    },
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    OpenWarning(request_id) {
      console.log("Show Warning");
      this.is_confirmed_delete = false;
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    updateStatus(id, status) {
      this.selected_requested = {
        id: id,
        status: status,
      };
      this.show_Warning_popUp = true;
    },
    async confirmUpdate(selected_requested) {
      let reqID = this.encryptIt(selected_requested.id);

      await axios
        .patch(`/daily_job_plans/${reqID}`, selected_requested)
        .then(() => {
          this.getData();
        });
      this.show_Warning_popUp = false;
    },
    async getData() {
      this.isLoading = true;
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.user_monthly_job_request_id = this.filter
        .user_monthly_job_request_id
        ? this.filter.user_monthly_job_request_id
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&user_monthly_job_request_id=" +
        this.filter.user_monthly_job_request_id +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`daily_job_plans?${query}`)
        .then((response) => {
          this.daily_job_plans = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`daily_job_plan_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_daily_job_plan = true;
      await axios
        .post(`/daily_job_plans/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_daily_job_plan = false;
          this.is_deleted_daily_job_plan = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async Restore_this(id) {
      this.restore_daily_job_plan = true;
      await axios
        .post(`/daily_job_plans/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_daily_job_plan = false;
          this.is_restored_daily_job_plan = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
  },
};
</script>
